export default "__VITE_PUBLIC_ASSET__c463e335__"